import type {
    GetEmailSequenceTemplate_emailSequenceTemplate as EmailSequenceTemplate,
    GetSessionUser_loggedInUser as User,
} from 'nutshell-graphql-types';

export function canChangeTemplateGroup(
    viewingUser: User | null | undefined,
    emailSequenceTemplate: EmailSequenceTemplate | null | undefined,
    isEditingChildTemplate: boolean
): boolean {
    const userId =
        emailSequenceTemplate &&
        (emailSequenceTemplate.parent
            ? emailSequenceTemplate.parent.creatorUser.id
            : emailSequenceTemplate.creatorUser.id);

    const isTemplateManager = viewingUser ? viewingUser.permissions.canManageEmailTemplates : false;

    return (
        (!(Boolean(userId) && userId !== (viewingUser && viewingUser.id)) || isTemplateManager) &&
        !isEditingChildTemplate
    );
}
